import React, { ComponentProps, FC } from "react";
import { StyledText } from "../stitches/text";

type StitchesTextProps = ComponentProps<typeof StyledText>;

export interface InputProps extends StitchesTextProps {
  isExtra?: boolean;
  isError?: boolean;
}

// TODO : Add a custom input for submit etc. Only valid for type='text' for now
export const Text: FC<InputProps> = ({ isExtra = false, isError = false, children, ...props }) => (
  <StyledText isExtra={isExtra} isError={isError} {...props}>
    {children}
  </StyledText>
);
